module.exports = __webpack_public_path__ + "img/1.a74f98c8.png";